import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Contractor } from '../../objects/Contractor';
import { ContractorService } from '../../Services/contractor.service';

@Component({
  selector: 'app-contractor-edit',
  templateUrl: './contractor-edit.component.html',
  styleUrls: ['./contractor-edit.component.css']
})
export class ContractorEditComponent implements OnInit {
  contractor: Contractor = {
    id: 0, name: '', age: 0, jobTitle: '',
    cellPhone: '', email: '', salary: 0, hourlyWage: 0, imageContent: ''
  };

  isLoading = true;
  isSaving = false;
  imagePreview: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private contractorService: ContractorService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = parseInt(params.get('id') || '0', 10);
      if (id > 0) { this.load(id); }
    });
  }

  load(id: number): void {
    this.isLoading = true;
    this.contractorService.getContractorById(id).subscribe({
      next: c => {
        this.contractor = c;
        this.imagePreview = c.imageContent || null;
        this.isLoading = false;
      },
      error: () => { this.isLoading = false; }
    });
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) { return; }
    this.compressImage(file).then(compressed => {
      this.imagePreview = compressed;
      this.contractor.imageContent = compressed;
    });
  }

  private compressImage(file: File, maxPx = 240, quality = 0.75): Promise<string> {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = e => {
        const img = new Image();
        img.onload = () => {
          const ratio = Math.min(maxPx / img.width, maxPx / img.height, 1);
          const w = Math.round(img.width * ratio);
          const h = Math.round(img.height * ratio);
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          canvas.getContext('2d')!.drawImage(img, 0, 0, w, h);
          resolve(canvas.toDataURL('image/jpeg', quality));
        };
        img.src = e.target!.result as string;
      };
      reader.readAsDataURL(file);
    });
  }

  clearPhoto(): void {
    this.imagePreview = null;
    this.contractor.imageContent = '';
  }

  save(): void {
    this.isSaving = true;
    this.contractorService.editContractor(this.contractor).subscribe({
      next: () => {
        this.snackBar.open('Contractor saved', '', { duration: 2500 });
        this.router.navigate(['/contractors']);
      },
      error: () => {
        this.isSaving = false;
        this.snackBar.open('Failed to save — please try again', 'Dismiss', { duration: 4000 });
      }
    });
  }

  initials(name: string): string {
    if (!name) { return '?'; }
    const parts = name.trim().split(' ');
    return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase();
  }
}
